import { render, staticRenderFns } from "./PasajePage.vue?vue&type=template&id=3860379e"
import script from "./PasajePage.js?vue&type=script&lang=js&external"
export * from "./PasajePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports